import {Injectable} from '@angular/core';
import * as deviceUuid from 'device-uuid';
import {Md5} from 'ts-md5';

@Injectable()
export class ConfigService {
    regex = {
        phone: '^0{1}\\d{9}$',
        uaPhone: /[+][3][8]\d{10}$/,
        digits: /\d/,
        moneyTwoDigits: '^\\d*((\\.|,)?\\d{1,2})$',
        moneyThreeDigits: '^\\d*((\\.|,)?\\d{1,3})$',
        email: /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w+)+$/,
        time: /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/
    };

    /**
     * Device Info and UUID
     * Unique UUID based on Browser name and device UUID
     * https://github.com/biggora/device-uuid/
     * https://github.com/cotag/ts-md5
     */
    deviceAndBrowserUuid = {
        uniqueUuid: String(Md5.hashStr(`${new deviceUuid.DeviceUUID().parse().browser}${new deviceUuid.DeviceUUID().get()}`))
    };

    searchTimeout = 700;
    multiOptionTimeout = 400;

    /** Dialogs Config */
    canMinimizeDialog = {
        hasBackdrop: false,
        closeOnNavigation: false,
        disableClose: false,
    };

    rightSideDialogProps = {
        width: '1200px',
        height: '100%'
    };

    rightSideDialog = {
        width: '600px',
        maxWidth: '100%',
        height: this.rightSideDialogProps.height,
        position: {
            top: '0',
            bottom: '0',
            right: '90px'
        },
        panelClass: ['standard-dialog']
    };

    contractDialog = {...this.rightSideDialog, width: '1200px'};

    softPhone = {
        width: '100%',
        maxWidth: '360px',
        maxHeight: 'calc(100vh - 80px)',
        closeOnNavigation: false,
        disableClose: false,
        hasBackdrop: false,
        position: {
            top: '0',
            right: '90px'
        },
        panelClass: ['standard-dialog']
    };

    globalCrmSearch = {
        width: '100%',
        maxWidth: '900px',
        height: 'auto',
        maxHeight: '100%',
        closeOnNavigation: false,
        disableClose: false,
        hasBackdrop: false,
        position: {
            top: '0',
            left: '0'
        },
        panelClass: ['standard-dialog']
    };

    addItemDialog = {
        width: '100%',
        height: 'auto',
        maxWidth: '600px',
        maxHeight: '90vh',
        panelClass: ['standard-dialog']
    };

    viewItemDialog = {
        width: '100%',
        height: '100%',
        maxWidth: '800px',
        maxHeight: '90vh',
        closeOnNavigation: false,
        disableClose: false,
        panelClass: ['standard-dialog']
    };

    viewBillingDocDialog = {...this.viewItemDialog, maxWidth: '900px'};

    wideDialog = {
        maxWidth: '1200px',
        width: '100%',
        maxHeight: '90vh',
        height: 'auto',
        closeOnNavigation: false,
        disableClose: false,
        panelClass: ['standard-dialog']
    };

    crmDialog = {
        maxWidth: '1024px',
        width: '100%',
        height: 'auto',
        closeOnNavigation: false,
        disableClose: false,
        panelClass: ['standard-dialog']
    };

    itemsListDialog = {
        maxWidth: '1100px',
        width: '100%',
        height: '90%',
        closeOnNavigation: false,
        disableClose: false,
        panelClass: ['standard-dialog']
    };

    confirmationDialog = {
        maxWidth: '410px',
        width: '100%',
        closeOnNavigation: false,
        disableClose: false,
        panelClass: ['standard-dialog', 'confirmation-dialog']
    };

    /** Pagination */
    paginationConfig = {
        pageSizeOptions: [25, 50, 100],
        pageSize: 25,
    };

    randomBackgroundColors = [
        '#ddd7ff',
        '#c0f6e0',
        '#e5cedb',
        '#b0e0e6',
        '#a7aa9c',
        '#ddcae8',
        '#fff99a',
        '#faedff',
        '#c0f6e0',
    ];

    rangePickerLocale = {
        firstDay: 1,
        clearLabel: 'Очистити',
        cancelLabel: "Відмінити",
        applyLabel: 'Вибрати',
        daysOfWeek: ['Нд', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
        monthNames: ['Січень', 'Лютий', 'Березень', 'Квітень', 'Травень', 'Червень', 'Липень', 'Серпень', 'Вересень', 'Жовтень', 'Листопад', 'Грудень']
    };

    // @ts-ignore
    googleMapsConfig: google.maps.MapOptions = {
        center: {
            lat: 49.55,
            lng: 30.40,
        },
        zoom: 8,
        gestureHandling: 'cooperative',
        mapTypeControl: true,
        streetViewControl: true,
        fullscreenControl: false,
        scrollwheel: true,
    };
}
